import { createFileRoute } from '@tanstack/react-router';
import { MusicStylePage } from '../components/auth/MusicStylePage';

export const Route = createFileRoute('/music-style')({
  component: MusicStyle,
});

function MusicStyle() {
  return <MusicStylePage />;
}
